import React, {
  Component,
  PropTypes,
} from 'react'

import { connect } from 'react-redux'

import {
  Form,
} from 'antd'

import {
  loadSearchPages,
} from '../actions'


class _search extends Component {
  static propTypes = {
    form: PropTypes.object,
    onSearch: PropTypes.func,
  }
  componentDidMount () {
    this.props.form.validateFields()
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const {
      onSearch,
    } = this.props
    this.props.form.validateFields((err, { keyword }) => {
      if (!err) {
        onSearch(keyword)
      }
    })
  }

  render () {
    const {
      getFieldDecorator,
    } = this.props.form
    return (
      <form className="search-form" onSubmit={this.handleSubmit}>
        {getFieldDecorator('keyword', {
          rules: [{
            required: true,
            message: 'กรุณาระบุคำค้นหา',
            whitespace: true,
          }],
        })(
          <div>
            {
              <input
                type="search"
                className="search-field"
                placeholder="ค้นหาสินค้า"
                style={{ backgroundColor: '#fff' }}
              />
              }
          </div>
          )}
        <input type="submit" className="search-submit fa" value="&#xf002;" />
      </form>
    )
  }
}

const WrappedSearchForm = Form.create()(_search)

const mapDispatchToProps = dispatch => ({
  onSearch: (keyword) => {
    dispatch(loadSearchPages(keyword))
  },
})

export default connect(null, mapDispatchToProps)(WrappedSearchForm)



// WEBPACK FOOTER //
// ./src/components/search.js